import React, { useCallback, useEffect, useRef, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiService } from '../../services/apiService';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import JoditEditor from 'jodit-react';
import debounce from 'lodash.debounce';
import { faCopy } from '@fortawesome/free-solid-svg-icons';

function MemberProfile() {
    const id = localStorage.getItem('userid');
    const [editMode, setEditMode] = useState(false);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [profiles, setProfile] = useState([]);
    const [btnloading, setBtnLoading] = useState(false);
    const [formData, setFormData] = useState({
        current_password: '',
        password: '',
        password_confirmation: '',
        about: '',
        last_name: '',
        first_name: '',
    });
    const [preview, setPreview] = useState(null);
    const [errors, setErrors] = useState({});
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [passwordVisible1, setPasswordVisible1] = useState(false);
    const [passwordVisible2, setPasswordVisible2] = useState(false);
    const [errorsmessage, setErrorsMessage] = useState('');
    
    const contentRef = useRef("");
    const debouncedOnChange = debounce((value) => {
    const cleanValue = value === "<p><br></p>" ? "" : value;
        contentRef.current = cleanValue;
    }, 500);
    
    const fetchUserData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await apiService.getRequest(`/admin/users/${id}`);
            if(response && response.success){
                const user = response.data.user;
                setPreview(user.profile);
                setProfile(user);
                setFormData({ 
                    current_password: '',
                    password: '',
                    password_confirmation: '',
                    about: user.about, 
                    first_name: user.first_name, 
                    last_name: user.last_name, 
                });
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error("Error fetching user data", error);
        }finally {
            setLoading(false);
        }
    }, [id]);
    useEffect(() => {
        fetchUserData();
    }, [fetchUserData]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData({ ...formData, profile: file });
            const reader = new FileReader();
            reader.onloadend = () => setPreview(reader.result);
            reader.readAsDataURL(file);
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const validate = (data) => {
        const newErrors = {};
        if(formData.password.length > 0 || formData.current_password.length > 0 || formData.password_confirmation.length > 0 ){
            if (formData.password !== formData.password_confirmation) newErrors.password_confirmation = 'Passwords do not match';
            if (formData.current_password.length <= 0) newErrors.current_password = 'Current Passwords is required';
            if (formData.password.length <= 0) newErrors.password = 'New Passwords is required';
            if (formData.password_confirmation.length <= 0) newErrors.password_confirmation = 'Confirm Password is required';
            if (
                formData.current_password &&
                formData.password &&
                formData.current_password === formData.password
            ) {
                newErrors.password = 'New password cannot be the same as old password';
            }
        }
        if(profiles && profiles.user_type?.toLowerCase() === "admin"){
            if (!formData.first_name) newErrors.first_name = 'First name is required';
            if (!formData.last_name) newErrors.last_name = 'Last name is required';
        }
        if (!data.about || data.about.trim() === '') {
            errors.about = 'About is required.';
        }
            setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const contentValue = contentRef.current;
        const dataToSubmit = {
            ...formData,
            about: contentValue,
        };

        if (!validate(dataToSubmit)) return;
        setBtnLoading(true);

        const passwordFormat = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+\\|{};:/?.<>])[\w!@#$%^&*()\-_=+\\|{};:/?.<>]{8,}$/;
    
    // Check if the password matches the format
    if (formData.password && !passwordFormat.test(formData.password)) {
        setErrors(prevErrors => ({
            ...prevErrors,
            password: 'Password must be at least 8 characters long, include an uppercase letter, a number, and a special character.',
        }));
        setBtnLoading(false);
        return; // Exit the function if password is invalid
    }
        try {
            
            
            const formDataToSend = new FormData();
            
            Object.entries(dataToSubmit).forEach(([key, value]) => {
                formDataToSend.append(key, value);
            });

            const response = await apiService.postRequest('/update-profile', formDataToSend, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            if (response.success){
                toast(response.message || 'Updated successfully!');
                fetchUserData();
                setEditMode(false);
                setErrorsMessage("");
                setFormData({
                    current_password: '',
                    password: '',
                    password_confirmation: '',
                });
            }else{
                setErrors(response.errors || "");
                setErrorsMessage(response.message || "");
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error("Error updating user data", error);
        }finally {
            setBtnLoading(false);
        }
    };

    // Toggle password visibility
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };
    const togglePasswordVisibility1 = () => {
        setPasswordVisible1(!passwordVisible1);
    };
    const togglePasswordVisibility2 = () => {
        setPasswordVisible2(!passwordVisible2);
    };

    const sanitizeAndDisplayHTML = (html) => {
        const sanitizedHTML = html
        return sanitizedHTML;
    };

    const signatureRef = useRef(null);
    
    const handleCopy = () => {
        const el = signatureRef.current;
        if (el) {
            const range = document.createRange();
            range.selectNode(el);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            document.execCommand("copy");
            selection.removeAllRanges();
            toast("Signature copied! You can now paste it into your email.");
        }
    };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center" justifyContent="center">
                    <Grid size={{md:12,xs:12}} container alignItems="flex-start" justifyContent="space-between" flexDirection="row" className="jobseekerhead">
                        <h3>Profile</h3>
                    </Grid>
                    <Grid size={{md:12,xs:12}} container justifyContent="flex-end" className="gap-3">
                        { !editMode ? 
                        <button className='registersendbtn2 my-0' onClick={()=> setEditMode(true)}>Edit</button> :
                        <button className='registersendbtn1 my-0' onClick={()=> setEditMode(false)}>Cancel</button> }
                        <button className='registersendbtn1 my-0' onClick={() => navigate(-1)}>Back</button>
                    </Grid>
                    {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                        <Grid size={{md:11,xs:12}} container justifyContent="space-between" className="jobseekers_profilealls mt-4">
                            { !editMode ? 
                                <Grid size={{xs:12}} container justifyContent="center" className="mb-5">
                                    <div className='profile_imgshowdiv' >
                                        {profiles && profiles.profile ?
                                            <img src={profiles.profile} alt='profile'/>
                                        :<img src={require("../../assets/defaultprofile.svg").default} alt='profile'/>}
                                    </div>
                                </Grid>:
                                <Grid size={{xs:12}} container className="mb-5">
                                    <form className='row justify-content-center w-100' onSubmit={handleSubmit}>
                                        <Grid size={{ sm: 11, xs: 12 }} container justifyContent="space-between" className="add_memberfields">
                                            {/* Profile Picture Upload */}
                                            <Grid size={{ sm: 12, xs: 12 }} container flexDirection="column" alignItems="center" className="profile_uploadlab my-5">
                                                <div className="profile-upload-wrapper">
                                                    <label htmlFor="profile-upload-input" className="profile-upload-label_ineditpro">
                                                        {preview ? (
                                                            <img src={preview} alt="Profile Preview" className="profile-preview" />
                                                        ) : (
                                                            <div className="placeholder-icon">
                                                                <img src={require('../../assets/cameraicon.svg').default} alt='Upload' />
                                                            </div>
                                                        )}
                                                    </label>
                                                    <input
                                                        id="profile-upload-input"
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={handleImageChange}
                                                        style={{ display: 'none' }}
                                                    />
                                                </div>
                                                <small className='mt-2'>Update Profile Picture</small>
                                                <small className='mt-2 text-danger'>Note: Recomended size 100 X 100</small>
                                                <div className='w-100'>
                                                    {errors.profile && <p style={{ color: "red" }}>{errors.profile}</p>}
                                                </div>
                                            </Grid>
                                            {/* Password */}
                                            <Grid size={{ sm: 5.5, xs: 12 }} container flexDirection="column" className="mb-4">
                                                <span>Current password</span>
                                                <div className='d-flex input_witheye'>
                                                    <input
                                                        name="current_password"
                                                        type={passwordVisible1 ? 'text' : 'password'}
                                                        value={formData.current_password}
                                                        onChange={handleInputChange}
                                                        placeholder="Abcd123#"
                                                        style={{ width: '100%', paddingRight: '40px' }}
                                                    />
                                                    <button type="button" onClick={togglePasswordVisibility1}>
                                                        {passwordVisible1 ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                                    </button>
                                                </div>
                                                {errors.current_password && <p style={{ color: "red" }}>{errors.current_password}</p>}
                                            </Grid> 
                                            <Grid size={{ xs: 12 }} container justifyContent="space-between">
                                                <Grid size={{ sm: 5.5, xs: 12 }} container flexDirection="column" className="mb-4">
                                                    <span>New Password</span>
                                                    <div className='d-flex input_witheye'>
                                                        <input
                                                            name="password"
                                                            type={passwordVisible ? 'text' : 'password'}
                                                            value={formData.password}
                                                            onChange={handleInputChange}
                                                            placeholder="Abcd123#"
                                                            style={{ width: '100%', paddingRight: '40px' }}
                                                        />
                                                        <button type="button" onClick={togglePasswordVisibility}>
                                                            {passwordVisible ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                                        </button>
                                                    </div>
                                                    {errors.password && <p style={{ color: "red" }}>{errors.password}</p>}
                                                </Grid>
                                                {/* Confirm Password */}
                                                <Grid size={{ sm: 5.5, xs: 12 }} container flexDirection="column" className="mb-4">
                                                    <span>Confirm Password</span>
                                                    <div className='d-flex input_witheye'>
                                                        <input
                                                            name="password_confirmation"
                                                            value={formData.password_confirmation}
                                                            onChange={handleInputChange}
                                                            type={passwordVisible2 ? 'text' : 'password'}
                                                            placeholder="Abcd123#"
                                                            style={{ width: '100%', paddingRight: '40px' }}
                                                        />
                                                        <button type="button" onClick={togglePasswordVisibility2}>
                                                            {passwordVisible2 ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                                        </button>
                                                    </div>
                                                    {errors.password_confirmation && <p style={{ color: "red" }}>{errors.password_confirmation}</p>}
                                                </Grid>
                                                {profiles && profiles.user_type?.toLowerCase() === "admin" &&
                                                <Grid size={{xs:12}} container justifyContent="space-between">
                                                    <Grid size={{ sm: 5.5, xs: 12 }} container flexDirection="column" className="mb-4 memberfield_individual">
                                                        <span>First Name</span>
                                                        <input
                                                            type="text"
                                                            name="first_name"
                                                            value={formData.first_name}
                                                            onChange={handleInputChange}
                                                            onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
                                                        />
                                                        {errors.first_name && <p style={{ color: "red" }}>{errors.first_name}</p>}
                                                    </Grid>
                                                    <Grid size={{ sm: 5.5, xs: 12 }} container flexDirection="column" className="mb-4 memberfield_individual">
                                                        <span>Last Name</span>
                                                        <input
                                                            type="text"
                                                            name="last_name"
                                                            value={formData.last_name}
                                                            onChange={handleInputChange}
                                                            onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
                                                        />
                                                        {errors.last_name && <p style={{ color: "red" }}>{errors.last_name}</p>}
                                                    </Grid>
                                                </Grid>
                                                }
                                                <Grid size={{xs:12}} container className="editor_sunsinput">
                                                    <span>About<small className='red_starimpo'>*</small></span>
                                                    <JoditEditor
                                                        value={formData.about}
                                                        config={{
                                                            pasteHTML: '',
                                                            cleanHTML: false,
                                                            askBeforePasteHTML: false,
                                                            askBeforePasteFromWord: false,
                                                            disablePlugins: ['pasteStorage'], // optionally disable paste-related cleanup plugins
                                                            iframe: false,
                                                            editHTMLDocumentMode: false,
                                                            enableDragAndDropFileToEditor: false,

                                                            uploader: {
                                                            insertImageAsBase64URI: false,
                                                            },

                                                            processPasteHTML: (html) => {
                                                            return html.replace(/<img[^>]*>/gi, "");
                                                            },

                                                            enter: "BR",
                                                            beautifyHTML: false,
                                                            events: {
                                                                beforePaste: (event) => {
                                                                    const clipboardData =
                                                                    event?.clipboardData || window.clipboardData;

                                                                    if (!clipboardData?.items) return;

                                                                    for (let item of clipboardData.items) {
                                                                    if (item.type?.includes("image")) {
                                                                        event.preventDefault(); // ✅ silently block
                                                                        return false;
                                                                    }
                                                                    }
                                                                },
                                                                afterPaste: () => {
                                                                    const editor = document.querySelector(".jodit-wysiwyg");

                                                                    if (!editor) return;

                                                                    const images = editor.querySelectorAll("img");
                                                                    images.forEach((img) => img.remove());
                                                                },
                                                            },
                                                            paste: {
                                                            cleanOnPaste: false,
                                                            replaceNewlines: false
                                                            },

                                                            
                                                            controls: {
                                                                font: {
                                                                    list: {
                                                                        'calibri': 'Calibri'
                                                                    }
                                                                },
                                                                removeFormat: {
                                                                    name: 'removeFormat',
                                                                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free v7.0.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M178.5 416l123 0 65.3-65.3-173.5-173.5-126.7 126.7 112 112zM224 480l-45.5 0c-17 0-33.3-6.7-45.3-18.7L17 345C6.1 334.1 0 319.4 0 304s6.1-30.1 17-41L263 17C273.9 6.1 288.6 0 304 0s30.1 6.1 41 17L527 199c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41l-135 135 120 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0z"/></svg>',
                                                                    tooltip: 'Remove Format',
                                                                },
                                                                removeBg: {
                                                                    name: "removeBg",
                                                                    tooltip: "Remove Background Color",
                                                                    icon: "eraser",
                                                                    exec: (editor) => {
                                                                    editor.s.focus();
                                                                
                                                                    const sel = editor.s.sel;
                                                                    if (sel && sel.rangeCount > 0) {
                                                                        const range = sel.getRangeAt(0);
                                                                        const contents = range.cloneContents();
                                                                        const div = editor.ownerDocument.createElement("div");
                                                                        div.appendChild(contents);
                                                                        
                                                                        const elements = div.querySelectorAll("*");
                                                                        elements.forEach(el => {
                                                                        if (el.style && el.style.backgroundColor) {
                                                                            el.style.backgroundColor = "";
                                                                        }
                                                                        });
                                                                        
                                                                        editor.selection.remove();
                                                                        editor.selection.insertHTML(div.innerHTML);
                                                                    }
                                                                    }
                                                                },
                                                                fontsize: {
                                                                    list: {
                                                                    "12px": "Paragraph - 12",
                                                                    "14px": "Small - 14",
                                                                    "16px": "Default - 16",
                                                                    "18px": "Medium - 18",
                                                                    "24px": "Large - 24"
                                                                    }
                                                                }, 
                                                            },
                                                            width: "100%",
                                                            minWidth: "500px",
                                                            toolbarAdaptive: false,
                                                            toolbarSticky: false,
                                                            buttons: [
                                                                "source", "|",
                                                                "bold", "italic", "underline", "strikethrough","spellcheck", "|",
                                                                "fontsize", "brush","removeBg", "|", // Font size, font style, text color // "font",
                                                                "ul", "ol", "|",
                                                                "align", "|",
                                                                "table", "link", "|",
                                                                "undo", "redo", "removeFormat", "|",
                                                                "hr", "fullsize" // Additional options
                                                            ], 
                                                            useIframe: false,
                                                            defaultFont: "calibri", // Default font
                                                            style: {
                                                                fontFamily: "calibri", // Set font globally
                                                            },
                                                            showCharsCounter: false, // Hides character counter
                                                            showWordsCounter: false, // Hides word counter
                                                        }}
                                                        onChange={debouncedOnChange}
                                                    />
                                                    {errors.about && <p style={{ color: "red" }}>{errors.about}</p>}
                                                </Grid>
                                            </Grid>
                                            {errorsmessage && <p style={{ color: "red", textAlign: "center" }}>{errorsmessage}</p>}
                                            {/* Submit Button */}
                                            <Grid size={{sm:12,xs:12}} container justifyContent="flex-end" className="gap-lg-5 gap-3 my-3">
                                                <button type="button" className='registersendbtn1 my-0' onClick={()=> setEditMode(false)}>Cancel</button>
                                                <button type="submit" className='registersendbtn2 my-0' >{btnloading ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Save'}</button>
                                            </Grid>
                                        </Grid>
                                    </form>
                                </Grid>
                            }
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>First Name</span>
                                <p>{profiles.first_name}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Last Name</span>
                                <p>{profiles.last_name}</p>
                            </Grid>
                            <Grid size={{sm:12,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Email Id</span>
                                <p>{profiles.email}</p>
                            </Grid>
                            {profiles && profiles.user_type?.toLowerCase() !== "admin" && <>
                            {profiles && profiles.address &&
                            <Grid size={{sm:12,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Address</span>
                                <p>{profiles.address}</p>
                            </Grid>}
                            <Grid size={{sm:12,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Review Allowed</span>
                                <p>{profiles.is_review === 1 ? "Yes" : "No"}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Date of Birth</span>
                                <p>{profiles.dob}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Manager</span>
                                <p>{profiles.manager_name || "No Data"}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container>
                                <Grid size={{xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>Personal Phone Number</span>
                                    <p>{profiles.phone_number || "No Data"}</p>
                                </Grid>
                                {profiles && profiles.whatsapp_number &&
                                <Grid size={{xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>Personal Whatsapp Number</span>
                                    <p>{profiles.whatsapp_number || "No Data"}</p>
                                </Grid>}
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container>
                                <Grid size={{xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>Business Phone Number</span>
                                    <p>{profiles.business_number || "No Data"}</p>
                                </Grid>
                                {profiles && profiles.business_whatsapp_number &&
                                <Grid size={{xs:12}} container flexDirection="column" className="seekprof_borders">
                                    <span>Business Whatsapp Number</span>
                                    <p>{profiles.business_whatsapp_number || "No Data"}</p>
                                </Grid>}
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Industry Start Date</span>
                                <p>{profiles.industry_start_date || "No Data"}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Start Date</span>
                                <p>{profiles.start_date || "No Data"}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Job Title (Linkedin)</span>
                                <p>{profiles.job_title || "No Data"}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Linkedin URL</span>
                                {profiles && profiles.linkedin_url ?
                                <Link to={profiles.linkedin_url} target='_blank'>View</Link> :
                                <p>No Data</p>}
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Partnership Status</span>
                                <p>{profiles.partnership_status || "No Data"}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Primary Department</span>
                                <p>{profiles.primary_department || "No Data"}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Industry Sector</span>
                                <p>{profiles.industry_sector || "No Data"}</p>
                            </Grid>
                            </>}
                        </Grid>
                        {profiles && profiles.about &&
                        <Grid size={{xs:11}} container flexDirection="column" className="mb-4">
                            <span style={{color: "#828282" ,marginBottom: "10px", fontWeight: "500"}}>About</span>
                            <div style={{fontFamily:"unset !important"}} className='w-100 caliberifontsset' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(profiles.about || "No Data") }} />
                        </Grid>}
                        {profiles && profiles.user_type?.toLowerCase() !== "admin" &&
                        <Grid size={{xs:11}} container className="mb-4 gap-2" flexDirection="column">
                            <div style={{ width: "max-content", display: "flex", flexDirection: "column", alignItems: "flex-end"}}>
                                <div
                                    ref={signatureRef}
                                    style={{
                                    fontFamily: "Arial, sans-serif",
                                    color: "#000",
                                    backgroundColor: "#fff",
                                    borderRadius: "10px",
                                    padding: "16px",
                                    width: "400px",
                                    }}
                                >
                                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                                        {preview ? (
                                            <img src={preview} alt="Profile" style={{ borderRadius: "50%", width: "70px", height: "70px" }} />
                                        ) : (
                                            <img src={require('../../assets/defaultprofile.png')} alt="Profile" style={{ borderRadius: "50%", width: "70px", height: "70px" }} />
                                        )}
                                        <p style={{ marginTop: "10px",marginLeft: "15px", fontSize: "14px" }}>
                                            Connect with us: <br/>
                                            <a href={`${profiles.instagram_link}`} style={{ marginRight:"10px" }} target="_blank" rel="noopener noreferrer">
                                                <img
                                                src={require("../../assets/instagram_email.png")}
                                                alt="globe"
                                                style={{ width: "30px" , height: "30px"}}
                                            /></a>
                                            {profiles.linkedin_url &&
                                                <a href={`${profiles.linkedin_url}`} target="_blank" rel="noopener noreferrer"><img
                                                    src={require("../../assets/linkedin_email.png")}
                                                    alt="globe"
                                                    style={{width: "30px" , height: "30px" }}
                                                /></a>
                                            }
                                        </p>
                                        <img
                                            src={profiles.techpossible_logo}
                                            alt="Profile"
                                            style={{marginLeft: "15px", width: "160px" }}
                                        />
                                    </div>
                                    <div style={{marginTop: "15px", display: "flex", alignItems: "start" }}>
                                        <div style={{ marginLeft: "15px", fontSize: "14px"  }}>
                                            <div style={{ marginBottom: "15px" }}>
                                                <h5 style={{ margin: "0", color: "#000",fontWeight:"600" }}>{profiles.first_name} {profiles.last_name}</h5>
                                                <p style={{ margin: "2px 0", fontSize: "14px" }}>
                                                    {profiles.partnership_status && profiles.partnership_status !== "Not a Partner" ? <>
                                                        {profiles.partnership_status} @ {profiles.industry_sector}</>: <>{profiles.job_title && <>{profiles.job_title} @ {profiles.industry_sector}</>}</>}
                                                </p>
                                            </div>
                                            {profiles.company_address && <p style={{display:"flex"}}><img
                                            src={require("../../assets/email_navigation.png")}
                                            alt="navi"
                                            style={{ width: "16px" ,marginRight: "8px", height: "16px" }}
                                        /> <span style={{width:"calc(100% - 24px)"}}>{profiles.company_address}</span></p>}
                                            <p><img
                                                src={require("../../assets/email_at_sign.png")}
                                                alt="email"
                                                style={{ width: "16px" ,marginRight: "8px", height: "16px" }}
                                            /> <a href={`mailto:${profiles.email}`} target="_blank" rel="noopener noreferrer">{profiles.email}</a></p>
                                            {profiles.business_number &&
                                            <p><img
                                                src={require("../../assets/email_phone.png")}
                                                alt="phone"
                                                style={{ width: "16px" ,marginRight: "8px", height: "16px" }}
                                            /> 
                                                <a href={`tel:${profiles.business_number}`} target="_blank" rel="noopener noreferrer">{profiles.business_number}</a></p>}
                                            <p style={{marginBottom:"0px"}}><img
                                                src={require("../../assets/email_globe.png")}
                                                alt="globe"
                                                style={{ width: "16px" ,marginRight: "8px", height: "16px" }}
                                            /> <a href={`https://${profiles.website_link}`} target="_blank" rel="noopener noreferrer">{profiles.website_link}</a></p>
                                        </div>
                                    </div>
                                </div>
                                <button type='button'
                                    onClick={handleCopy}
                                    style={{
                                    background: "#fff",
                                    color: "#c2185b",
                                    border: "none",
                                    fontWeight:500,
                                    padding: "5px 12px",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    marginBottom: "10px",
                                    }}
                                >
                                    <FontAwesomeIcon icon={faCopy} />  Copy
                                </button>
                            </div>
                        </Grid>}
                    </>}
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default MemberProfile
